import React, { useEffect, useState } from 'react'
import GSTReport from './GSTReport'
import { useSearchParams } from 'react-router-dom'
import { gstReport } from '../../common/constants'
import HisabReport from './generateHisabReport/HisabReport'
import GSTReportV2 from './GSTReportV2'
import CreditReport from './CreditReport'
import CreditSummaryReport from './CreditSummaryReport'
import CreditUsageReport from './CreditUsageReport'
import BusAndCargoMemo from './BusAndCargoMemo'
import PartywiseTransactionReport from './PartywiseCreditLimitReport/PartywiseCreditLimitTransactionReport'
import PartywiseSummaryReport from './PartywiseCreditLimitReport/PartyCreditLimitSummaryReport'
import BranchwiseCollectionAndDispatchMemoCollection from './BranchwiseCollectionAndDispatchMemoCollection'
import FranchiseePendingTopayReport from './FranchiseePendingTopayReport/FranchiseePendingTopayReport'
import FranchiseeSettlementReport from './FranchiseeSettlementReport/FranchiseeSettlementReport'
import MpesaTransactionReport from './MpesaTransactionReport/MpesaTransactionReport'
import GSTReportV1 from './GSTReportV1'
import OGPLReport from './OGPLReport/OGPLReport'
import { BranchDueReport } from './BranchDueReport'
import { BranchPayable } from './BranchPayable'
import { BookingSummary } from './BookingSummary'
import { ProfileLossReport } from './ProfileLossReport'
import OGCLReport from './OGCLReport'
const AcountingReport = () => {
  const [searchParams] = useSearchParams()
  const [acountingNumber, setAcountingNumber] = useState(Number(searchParams.get('id')) || '')
  useEffect(() => {
    setAcountingNumber(Number(searchParams.get('id')))
  }, [searchParams])
  let acountingType
  switch (acountingNumber) {
    case 1: {
      acountingType = <GSTReport />
      break
    }
    case 2: {
      acountingType = <GSTReportV2 />
      break
    }
    case 3: {
      acountingType = <CreditReport />
      break
    }
    case 4: {
      acountingType = <CreditSummaryReport />
      break
    }
    case 5: {
      acountingType = <CreditUsageReport />
      break
    }
    case 6: {
      acountingType = <HisabReport />
      break
    }
    case 7: {
      acountingType = <BusAndCargoMemo />
      break
    }
    case 8: {
      acountingType = <PartywiseTransactionReport />
      break
    }
    case 9: {
      acountingType = <PartywiseSummaryReport />
      break
    }
    case 10: {
      acountingType = <FranchiseePendingTopayReport />
      break
    }
    case 11: {
      acountingType = <FranchiseeSettlementReport />
      break
    }
    case 12: {
      acountingType = <MpesaTransactionReport />
      break
    }
    case 13: {
      acountingType = <BranchwiseCollectionAndDispatchMemoCollection/>
      break
    }
    case 14: {
      acountingType = <BranchDueReport/>
      break
    }
    case 15: {
      acountingType = <BranchPayable/>
      break
    }
    case 16: {
      acountingType = <BookingSummary/>
      break
    }
    case 17: {
      acountingType = <ProfileLossReport/>
      break
    }
    case 18: {
      acountingType = <OGPLReport/>
      break
    }
    case 19: {
      acountingType = <OGCLReport/>
      break
    }
    case 20: {
      acountingType = <GSTReportV1/>
      break
    }
    default:
      acountingType = <GSTReport />
      break
  }
  return acountingType
}

export default AcountingReport
